import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

const LogoWrapper = styled(Link)`
  img {
    min-width: var(--width-logo);
  }
`;

const Logo: React.FC = () => {
  return (
    <LogoWrapper to="/">
      <StaticImage
        src="../assets/images/logo.svg"
        alt="Scripted by Kat Logo"
        loading="eager"
        placeholder="none"
        width={120}
      />
    </LogoWrapper>
  );
};

export default Logo;
